import type { Components } from '@mildang/mui';
import type { Theme } from '@mildang/mui';

const createContainer = ({ breakpoints }: Theme): Components => {
  return {
    MuiContainer: {
      defaultProps: {
        maxWidth: false,
      },
      styleOverrides: {
        root: {},
        /* Styles applied to the root element if `maxWidth="xs"`. */
        maxWidthXs: {
          [breakpoints.up('xs')]: {
            // maxWidth: Math.max(breakpoints.values.xs, 444),
            // maxWidth: Math.max(breakpoints.values.xs, 400),
            maxWidth: 400 + Number(16) * 2,
          },
        },
        /* Styles applied to the root element if `maxWidth="sm"`. */
        maxWidthSm: {
          [breakpoints.up('sm')]: {
            // maxWidth: breakpoints.values.sm,
            maxWidth: 720 + Number(24) * 2,
          },
        },
        /* Styles applied to the root element if `maxWidth="md"`. */
        maxWidthMd: {
          [breakpoints.up('md')]: {
            maxWidth: 1140 + Number(24) * 2,
          },
        },
        /* Styles applied to the root element if `maxWidth="lg"`. */
        // maxWidthLg: {
        //   [breakpoints.up('lg')]: {
        //     maxWidth: 1140,
        //   },
        // },

        /* Styles applied to the root element if `maxWidth="xl"`. */
        // maxWidthXl: {
        //   [breakpoints.up('xl')]: {
        //     maxWidth: breakpoints.values.xl,
        //   },
        // },
      },
    },
  };
};

export default createContainer;
